export const ORDERLINE_CARD_MODAL = {
  cancelOrderWithPendingPayment: 'cancelOrderWithPendingPayment',
  invoiceRequested: 'invoiceRequested',
  mobilePlanAskForHelpModal: 'mobilePlanAskForHelpModal',
}
